
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 120 120","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M78 57a35 35 0 11-27.145-34.107L48.23 34.294A23.3 23.3 0 1066.3 57H78zM69 87.727l7.767-6.726 24.304 28.064-7.767 6.726z","fill":"#EAEDF2"}}),_c('path',{attrs:{"d":"M78.915 48.764A33.5 33.5 0 1153.84 22.43M66.705 91.561l9.071-7.856 21.696 25.054-9.07 7.856z","stroke":"#000"}}),_c('mask',{attrs:{"id":"empty_state_service_picker_svg__a","fill":"#fff"}},[_c('path',{attrs:{"d":"M62.913 84.312l6.23-5.395 5.201 6.005-6.23 5.395-5.2-6.005z"}})]),_c('path',{attrs:{"d":"M68.388 79.571l5.2 6.006 1.512-1.31-5.2-6.005-1.512 1.31zm.482 10.092l-5.2-6.006-1.513 1.31 5.201 6.005 1.512-1.31z","fill":"#000","mask":"url(#empty_state_service_picker_svg__a)"}}),_c('path',{attrs:{"d":"M69.319 52.087A23.5 23.5 0 1149.804 31.81M55 9l-3 39.517h30.552L82.167 57l10-8.483H108L110 8 55 9z","stroke":"#000"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M68.193 21.374l20.22 19.888 5.946-6.084L74.137 15.29l-5.944 6.084z","fill":"#F6B2CA"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M88.178 15.193L68.29 35.414l6.085 5.945 19.887-20.222-6.084-5.944z","fill":"#F6B2CA"}})])
          )
        }
      }
    